import React from 'react';
import MultiselectRW from 'react-widgets/Multiselect';
import "react-widgets/styles.css";
import PropTypes from 'prop-types';
import cx from 'classnames';
import '@/scss/components/common/MultiselectDropdown.scss';

/* dropdown that doesn't have redux or redux-form dependencies */
const Multiselect = (props) => {
	let rootClassName = cx('Multiselect', {'tropic-invalid': props.touched && props.error});
	return (
		<div id={props.id} className={rootClassName}>
			<label> {props.label} </label>
			{/* requires value to be an array and onBlur needs to be rewritten for react-widgets Multiselect to be used with redux-form */}
			<MultiselectRW
				data = {props.data}
				error = {props.error}
				textField = {props.textField}
				dataKey = {props.valueField}
				value={props.value}
				onChange={props.onChange}
				onBlur={() => props.onBlur(props.value)}
				placeholder={props.placeholder}
				disabled={props.disabled}
				filter='contains'
			/>
			{props.touched && props.error &&
				<div className={rootClassName + ' error'}>
					{/* kinda hacky, but bootstrap's .invalid-feedback must be a sibling of
					a .form-control.is-invalid but having it inside of an .input-group forces
					it to be inline with the input */}
					<div className='form-control is-invalid d-none'></div>
					<div className='invalid-feedback'>
						{props.error}
					</div>
				</div>
			}
		</div>
	);
};

Multiselect.propTypes = {
	id: PropTypes.string.isRequired,
	data: PropTypes.array.isRequired,
	value: PropTypes.array.isRequired,
	valueField: PropTypes.array.isRequired,
	textField: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func.isRequired,
	touched: PropTypes.bool.isRequired,
	error: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	label: PropTypes.string,
	disabled: PropTypes.bool
};

export default Multiselect;
